import { map } from 'lodash';

export const SURVEY_FORMAT_BASIC = 0;
export const SURVEY_FORMAT_SHORT = 1;
export const SURVEY_FORMAT_THIRD_PARTY = 3;
export const QUESTION_SINGLE = 0;
export const QUESTION_MULTIPLE = 1;
export const QUESTION_DESCRIPTION = 3;
export const QUESTION_RATING = 8;
export const QUESTION_SLIDER = 9;
export const QUESTION_OPEN_ENDED = 10;
export const QUESTION_NUMERICAL_OPEN_ENDED = 11;
export const QUESTION_RANKING = 12;
export const QUESTION_MATRIX_SINGLE = 13;
export const QUESTION_MATRIX_MULTIPLE = 14;
export const QUESTION_NPS = 15;
export const QUESTION_MATRIX_VAN_WESTENDORP = 16;
export const QUESTION_MATRIX_MAXDIFF = 17;
export const QUESTION_MATRIX_BIPOLAR = 18;
export const QUESTION_DRILLDOWN = 19;
export const QUESTION_MATRIX_OPEN_ENDED = 20;
export const QUESTION_MATRIX_OPEN_ENDED_NUMERIC = 21;
export const QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM = 22;
export const ANSWER_DEFAULT = 0;
export const ANSWER_OTHER = 1;
export const ANSWER_NONE_OF_THE_ABOVE = 2;
export const SHUFFLE_NONE = 0;
export const SHUFFLE_WITH_LAST_FIXED = 1;
export const SHUFFLE_ALL = 2;
export const SHUFFLE_REVERSE = 3;
export const SHUFFLE_REVERSE_WITH_LAST_FIXED = 4;
export const SHUFFLE_REVERSE_WITH_LAST_TWO_FIXED = 5;
export const SHUFFLE_WITH_LAST_TWO_FIXED = 6;
export const SHUFFLE_WITH_FIRST_FIXED = 19;
export const SHUFFLE_WITH_FIRST_TWO_FIXED = 20;
export const SHUFFLE_WITH_FIRST_AND_LAST_FIXED = 25;

// Matrix Specific shuffles
export const SHUFFLE_ROWS = 7;
export const SHUFFLE_ROWS_REVERSE = 8;
export const SHUFFLE_ROWS_REVERSE_WITH_LAST_FIXED = 9;
export const SHUFFLE_ROWS_REVERSE_WITH_LAST_TWO_FIXED = 10;
export const SHUFFLE_ROWS_WITH_LAST_FIXED = 11;
export const SHUFFLE_ROWS_WITH_LAST_TWO_FIXED = 12;
export const SHUFFLE_ROWS_WITH_FIRST_FIXED = 21;
export const SHUFFLE_ROWS_WITH_FIRST_TWO_FIXED = 22;
export const SHUFFLE_ROWS_WITH_FIRST_AND_LAST_FIXED = 26;
export const SHUFFLE_ROWS_REVERSE_WITH_FIRST_FIXED = 28;
export const SHUFFLE_ROWS_REVERSE_WITH_FIRST_TWO_FIXED = 29;

export const SHUFFLE_COLUMNS = 13;
export const SHUFFLE_COLUMNS_REVERSE = 14;
export const SHUFFLE_COLUMNS_REVERSE_WITH_LAST_FIXED = 15;
export const SHUFFLE_COLUMNS_REVERSE_WITH_LAST_TWO_FIXED = 16;
export const SHUFFLE_COLUMNS_WITH_LAST_FIXED = 17;
export const SHUFFLE_COLUMNS_WITH_LAST_TWO_FIXED = 18;
export const SHUFFLE_COLUMNS_WITH_FIRST_FIXED = 23;
export const SHUFFLE_COLUMNS_WITH_FIRST_TWO_FIXED = 24;
export const SHUFFLE_COLUMNS_WITH_FIRST_AND_LAST_FIXED = 27;

export const SHUFFLE_ROWS_AND_SHUFFLE_COLUMNS_REVERSE = 30;
export const SHUFFLE_MATRICES_SAME_ORDER = 19;
export const INTERNAL_SURVEY_TYPE = 'PublisherOwn';
export const SURVEY_TYPE_SIMILAR_ON_EXPIRE = 'similar';
export const SURVEY_TYPE_ADDITIONAL_ON_EXPIRE = 'additional';

// It will be used to send the request post data as url encoded
export const TRANSFORMATION_DATA_TYPE_URL_PARAMS = 'urlParams';
// It will be used to send the request post data as json
export const TRANSFORMATION_DATA_TYPE_JSON = 'json';

export const SUPPORTED_LANGUAGES = [
  {
    key: 'en',
    value: 'English',
  },
  {
    key: 'el',
    value: 'Ελληνικά',
  },
  {
    key: 'ru',
    value: 'русский',
  },
  {
    key: 'es',
    value: 'Español',
  },
  {
    key: 'de',
    value: 'Deutsch',
  },
  {
    key: 'fr',
    value: 'Français',
  },
  {
    key: 'it',
    value: 'Italiano',
  },
  {
    key: 'ar',
    value: 'العربية',
  },
  {
    key: 'hi',
    value: 'हिंदी',
  },
  {
    key: 'tr',
    value: 'Türkçe',
  },
  {
    key: 'pt',
    value: 'Português',
  },
  {
    key: 'ja',
    value: '日本語',
  },
  {
    key: 'zh',
    value: '中文',
  },
  {
    key: 'da',
    value: 'Dansk',
  },
  {
    key: 'sv',
    value: 'Svenska',
  },
  {
    key: 'bg',
    value: 'български',
  },
  {
    key: 'ro',
    value: 'Română',
  },
  {
    key: 'id',
    value: 'Indonesian',
  },
  {
    key: 'ph',
    value: 'Filipino',
  },
  {
    key: 'cs',
    value: 'český',
  },
  {
    key: 'nl',
    value: 'Nederlands',
  },
  {
    key: 'sr',
    value: 'Српски',
  },
  {
    key: 'fi',
    value: 'Suomi',
  },
  {
    key: 'vi',
    value: 'Tiếng Việt',
  },
  {
    key: 'th',
    value: 'ไทย',
  },
  {
    key: 'pl',
    value: 'Polski',
  },
  {
    key: 'ko',
    value: '한국어', // korean
  },
  {
    key: 'hu',
    value: 'Magyar', // hungarian
  },
  {
    key: 'zh-Hant',
    value: '繁體中文', // traditional chinese
  },
  {
    key: 'no',
    value: 'Norsk', // norwegian
  },
  {
    key: 'eg',
    value: 'المصرية', // Egyptian
  },
  {
    key: 'uk',
    value: 'Українська', // ukranian
  },
  {
    key: 'he',
    value: 'עברית', // Hebrew
  },
  {
    key: 'bn',
    value: 'বাঙালী', // Bengali
  },
  {
    key: 'sk',
    value: 'Slovenčina', // slovak
  },
  {
    key: 'fa',
    value: 'فارسی', // persian
  },
  {
    key: 'az',
    value: 'Azərbaycanca', // azerbaijani
  },
  {
    key: 'ka',
    value: 'ქართული', // georgian
  },
  {
    key: 'lt',
    value: 'Lietuvių', // lithuanian
  },
  {
    key: 'pa',
    value: 'ਪੰਜਾਬੀ', // punjabi
  },
  {
    key: 'ps',
    value: 'پښتو', // pashto
  },
  {
    key: 'et',
    value: 'Eesti', // Estonian
  },
  {
    key: 'uz',
    value: 'Uzbekų', // Uzbek
  },
  {
    key: 'lv',
    value: 'Latviešu valoda',
  },
  {
    key: 'ms',
    value: 'Bahasa Melayu',
  },
  {
    key: 'ur',
    value: 'اردو',
  },
  {
    key: 'ur-roman',
    value: 'Urdu Roman',
  },
  {
    key: 'sq',
    value: 'Shqip',
  },
];
export const MINIMUM_POSTAL_CODE_LENGTH = 2;

// https://en.wikipedia.org/wiki/Postal_code#Character_sets
export const INVALID_POSTAL_CODE_CHARS = /[^0-9a-zA-Z-‐]/g;

export const BLANK_PIPING_ANSWER = '______';

export const GENERIC_DISQUALIFICATION = 'generic_disqualification';
export const SANITY_DISQUALIFICATION = 'sanity_disqualification';
export const DISQUALIFICATION_USER_UNDERAGE = 'user_underage';
export const QUALITY_DISQUALIFICATION = 'quality_disqualification';
export const PROFILING_DISQUALIFICATION = 'profiling_disqualification';

export const MAX_PARTICIPATION_WAIT_SUCCESS_MILLISECONDS = 15000;
export const MAX_PARTICIPATION_WAIT_SCREENOUT_MILLISECONDS = 6000;

export const PARTICIPATION_RESULT_DISPLAY_MILLISECONDS = 10000;

export const PARTICIPATION_STATUS = {
  // Redirect to Q1 screen  - Thank you screen
  SUCCESS: 'success',
  // Redirect to Q2 screen  - Screen-out screen
  SCREEN_OUT: 'screen_out',
  // Redirect to Q3 screen  - Survey Expired screen
  SURVEY_EXPIRED: 'survey_expired',
  // Redirect to Q9 screen  - Survey Replaced in Background screen
  SURVEY_REPLACED: 'survey_replaced',
  // Redirect to Q3 screen  - Underage screen-out screen
  DISQUALIFICATION_USER_UNDERAGE: 'underage_screen_out',
  // Redirect to Q11 screen - VPN screen-out screen
  VPN: 'vpn',
  // final quality screenout means that we won't be trying
  // to provide respondent with another survey after this
  // Redirect to Q12 screen - Quality screen-out screen
  FINAL_QUALITY_SCREEN_OUT: 'final_quality_screen_out',
  // Redirect to Q4 screen  - Quality mid screen-out screen
  TENTATIVE_QUALITY_SCREEN_OUT: 'tentantive_quality_screen_out',
  // Redirect to Q3 screen  - User Rejection screen
  USER_REJECTION: 'user_rejection',
  // Respondent has already answered once the survey
  SURVEY_ALREADY_TAKEN: 'survey_already_taken',
  // Survey is not active
  SURVEY_NOT_ACTIVE: 'survey_not_active',
};

export const EXPECTED_PAYLOAD_STATUS_ENUMS = [
  'pending',
  'processing',
  'success',
  'screened_out',
];

export const EXPECTED_PARTICIPATION_STATUS_ENUMS = map(
  PARTICIPATION_STATUS,
  (status) => status,
);
export const PENDING_PARTICIPATION_STATUSES = ['pending', 'processing'];

export const CARRY_FORWARD_ANSWER_OPTIONS = {
  GREATER_THAN: 'GREATER_THAN',
  LESSER_THAN: 'LESSER_THAN',
  EQUAL_TO: 'EQUAL_TO',
  HIGHEST_VALUE: 'HIGHEST_VALUE',
  LOWEST_VALUE: 'LOWEST_VALUE',
  SELECTED_VALUES: 'SELECTED_VALUES',
  UNSELECTED_VALUES: 'UNSELECTED_VALUES',
  VALUE: 'VALUE',
  SELECTED_COLUMNS: 'SELECTED_COLUMNS',
  UNSELECTED_COLUMNS: 'UNSELECTED_COLUMNS',
  SELECTED_FOR_ROW: 'SELECTED_FOR_ROW',
  UNSELECTED_FOR_ROW: 'UNSELECTED_FOR_ROW',
  SELECTED_FOR_COLUMN: 'SELECTED_FOR_COLUMN',
  UNSELECTED_FOR_COLUMN: 'UNSELECTED_FOR_COLUMN',
  MATRIX_EQUAL: 'MATRIX_EQUAL',
  MATRIX_NOT_EQUAL: 'MATRIX_NOT_EQUAL',
  MATRIX_HIGHEST_VALUE: 'MATRIX_HIGHEST_VALUE',
  MATRIX_LOWEST_VALUE: 'MATRIX_LOWEST_VALUE',
  MATRIX_GREATER_THAN: 'MATRIX_GREATER_THAN',
  MATRIX_EQUAL_GREATER_THAN: 'MATRIX_EQUAL_GREATER_THAN',
  MATRIX_LESSER_THAN: 'MATRIX_LESSER_THAN',
  MATRIX_EQUAL_LESSER_THAN: 'MATRIX_EQUAL_LESSER_THAN',
};

export const MEDIA_TYPE_IMAGE = 'image';
export const MEDIA_TYPE_AUDIO = 'audio';
export const MEDIA_TYPE_VIDEO = 'video';

export const MEDIA_TYPES = [
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_AUDIO,
  MEDIA_TYPE_VIDEO,
];
export const INTERACTIVE_MEDIA_TYPES = [MEDIA_TYPE_AUDIO, MEDIA_TYPE_VIDEO];

export const GROUP_TYPE_BASIC = 'BASIC';
export const GROUP_TYPE_AB = 'AB';
export const GROUP_TYPE_CONJOINT = 'CONJOINT';
export const GROUP_TYPE_VAN_WESTENDORP = 'VAN_WESTENDORP';
export const GROUP_TYPE_MAXDIFF = 'MAXDIFF';

export const IGNORED_UNHANDLED_PROMISE_REJECTION_CORS =
  'Blocked a frame with origin "https://wss.pollfish.com" from accessing a cross-origin frame.';
export const IGNORED_UNHANDLED_PROMISE_REJECTION_REASONS = [
  'Ethereum is not initialized',
  '$ is not defined',
  'goog is not defined',
  'chain is not set up',
  "Cannot read properties of null (reading 'tronlinkParams')",
  'Cannot redefine property: visibilityState',
  'Cannot redefine property: ethereum',
];
export const IGNORED_UNHANDLED_PROMISE_REJECTION_CORS_WEBSITES = [
  'https://earnbitmoon.club/',
  'https://claimbits.net/',
  'https://coinadster.com/',
  'https://esfaucets.com/',
];
export const IGNORED_UNHANDLED_PROMISE_REJECTION_BY_EXTENSION = [
  'chrome-extension://dhdgffkkebhmkfjojejmpbldmpobfkfo',
  'chrome-extension://eeagobfjdenkkddmbclomhiblgggliao',
  'chrome-extension://lgmpcpglpngdoalbgeoldeajfclnhafa',
  'chrome-extension://ebfidpplhabeedpnhjnobghokpiioolj',
  'moz-extension://8f96935c-b8a7-457a-8faa-c432eb9fff91',
];

export const DISTRIBUTION_LINK_ENDPAGE_BUTTON_TYPES = {
  // Done button
  DEFAULT: 0,
  // Results button
  RESULTS: 1,
  // Immediately redirect to custom end page
  CUSTOM: 2,
  // Without a button
  NO_REDIRECT: 3,
  // Immediately redirect to a prodege custom end page
  PRODEGE_CUSTOM: 4,
};

export const DISTRIBUTION_LINK_ENDPAGE_TYPES = {
  // Screen out with survey already taken
  SURVEY_ALREADY_TAKEN: 1,
  // Screen out with survey not active
  SURVEY_NOT_ACTIVE: 2,
  // Screen out with survey expired
  SURVEY_EXPIRED: 3,
};

export const SCREENING_ANSWER_TYPES = {
  ALLOWED: 'allowed',
  NOT_ALLOWED: 'notAllowed',
  STRICT_NOT_ALLOWED: 'strictNotAllowed',
};

export const POSTAL_DATA_PREFER_NOT_TO_SAY_ANSWER = 'PREFER_NOT_TO_SAY';

export const RANKING_QUESTION_LABELS_SORT_ASCENDING = 'ASC';
export const RANKING_QUESTION_LABELS_SORT_DESCENDING = 'DESC';

// the value which the mobile will send when make the survey completed request
// based on the current survey state, keep in mind the backend expect
// the following specified literals
export const SURVEY_STATE = {
  STARTING_SURVEY: 'starting',
  ANSWERING_DEMOGRAPHIC: 'demographics',
  ANSWERING_PROFILING: 'profiling',
  ANSWERING_SCREENING: 'screening',
  ANSWERING_SANITY: 'sanity',
  ANSWERING_SURVEY_QUESTION: 'surveyQuestion',
  COMPLETING_SURVEY: 'complete',
};

export const RECRUITMENT_CAMPAIGN_TEST_BANNER = 'user-recruitment-banner.png';

// recruitment campaign names
export const RECRUITMENT_CAMPAIGN_SWAGBUCKS = 'Swagbucks';

// available recruitment campaigns names
export const AVAILABLE_RECRUITMENT_CAMPAIGNS = [RECRUITMENT_CAMPAIGN_SWAGBUCKS];

// recruitment app banner (Swagbucks) image per user language
export const RECRUITMENT_CAMPAIGN_BANNER_SWAGBUCKS = {
  en: 'swagbucks_banner_en.png',
  fr: 'swagbucks_banner_fr.png',
  de: 'swagbucks_banner_de.png',
  es: 'swagbucks_banner_es.png',
};

export const FAILED_TO_LOAD_HCAPTCHA_SCRIPT =
  'Error while trying to load hcaptcha script';
export const FAILED_TO_LOAD_RECAPTCHA_SCRIPT =
  'Error while trying to load recaptcha script';

export const OFFERWALL_SORT_PROPERTY_DEFAULT_VALUE = 'ir';
export const OFFERWALL_SORT_OPTIONS = [
  {
    label: 'offerwall.sort.highest_reward',
    value: 'reward',
    order: 'desc',
  },
  {
    label: 'offerwall.sort.loi',
    value: 'loi',
    order: 'asc',
  },
  {
    label: 'offerwall.sort.matching',
    value: 'ir',
    order: 'desc',
  },
];

export const TEXT_LENGTH_LIMIT = 500;
